<template lang="pug">
.preview-item.my-4
  .text-sm.neutral500--text(v-if="title") {{ title }}
  .d-flex.justify-center
    slot
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null
    },
  },
}
</script>

<style scoped>
</style>